import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { GET_COMMUNITIES } from "./apiRoutes";

const mutateAddNewsletter = async ({
  id,
  data,
  news_number,
}: {
  id: string;
  data: FieldValues;
  news_number: number;
}) => {
  return await axiosAuth.post(
    `${GET_COMMUNITIES}/${id}/newsletter/${news_number}`,
    data,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

const useAddNewsletterMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      id: string;
      data: FieldValues;
      news_number: number;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddNewsletter,
    ...queryParams,
  });

export default useAddNewsletterMutation;
